import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { t } from '../services/textos';

const LARGURA = 367;
const PASSO = 45.3;

/** Espaço que o título (quando há) toma no topo do card. */
const ALTURA_DO_TITULO = 32;

/** Altura de um placar, para empilhar dois cards sem sobrepor (o título, quando há, soma no topo). */
export function alturaDoPlacar ({ linhas, titulo }) {
    return (titulo ? ALTURA_DO_TITULO : 0) + 28 + linhas.length * PASSO + 45;
}

/**
 * Painel de pontuação das fases (Figma, quadros 35 e 72): uma linha por
 * item, o fio e o TOTAL. `pontos: null` mostra "..." (ainda sem resposta do
 * servidor). `titulo` (opcional) nomeia o card, como "INDIVIDUAL" e "GRUPO" no Laboratório.
 * Devolve os objetos criados, para a cena poder redesenhar.
 */
export function desenharPlacar (scene, x, y, { linhas, total, titulo }) {
    const altura = alturaDoPlacar({ linhas, titulo });
    const g = scene.add.graphics();
    g.fillStyle(ARCADE_HEX.BRANCO, 0.4).fillRoundedRect(x, y, LARGURA, altura, 12);
    g.lineStyle(1, ARCADE_HEX.BRANCO, 1).strokeRoundedRect(x, y, LARGURA, altura, 12);

    const esquerda = x + 15, direita = x + LARGURA - 15;
    const linha = (rotulo, valor, centro, negrito = false) => [
        scene.add.text(esquerda, centro, rotulo, { ...ARCADE_TEXT.placar, fontStyle: negrito ? '700' : '400' }).setOrigin(0, 0.5),
        scene.add.text(direita, centro, valor, ARCADE_TEXT.placar).setOrigin(1, 0.5)
    ];

    const objetos = [g];
    const topo = y + (titulo ? ALTURA_DO_TITULO : 0);
    if (titulo) {
        objetos.push(scene.add.text(esquerda, y + 24, titulo, { ...ARCADE_TEXT.placar, fontStyle: '700' }).setOrigin(0, 0.5));
    }
    linhas.forEach(({ rotulo, pontos }, i) => {
        objetos.push(...linha(rotulo, pontos === null ? '...' : String(pontos), topo + 33 + i * PASSO));
    });

    const fim = topo + 13 + linhas.length * PASSO;
    g.lineStyle(1.4, ARCADE_HEX.TINTA, 1).lineBetween(esquerda, fim, direita, fim);
    objetos.push(...linha(t('geral.total'), String(total), fim + 29, true));
    return objetos;
}
